/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Open_Crm_UserInputs */

const cs_ebr_open_crm_user = /** @type {(inputs: Ebr_Open_Crm_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít uživatele v CRM`)
};

const en_ebr_open_crm_user = /** @type {(inputs: Ebr_Open_Crm_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open user in CRM`)
};

/**
* | output |
* | --- |
* | "Open user in CRM" |
*
* @param {Ebr_Open_Crm_UserInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_open_crm_user = /** @type {((inputs?: Ebr_Open_Crm_UserInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Open_Crm_UserInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_open_crm_user(inputs)
	return cs_ebr_open_crm_user(inputs)
});